// Module
var code = "<span class=\"text-nowrap\">{{ $ctrl.card_from }}-{{ $ctrl.card_to }}</span> ";
// Exports
export default code;